import { redirect } from './redirectHelper';

export const iframeOnLoadHelper = () => {
    const myIframe = document.querySelector('iframe');
    const predicates = myIframe.contentDocument.documentElement.querySelectorAll('.predicate');
    const resourceUrisURLs = myIframe.contentDocument.documentElement.querySelectorAll('.resource-uri');
    const resource = myIframe.contentDocument.documentElement.querySelectorAll('.resource.simple');
    const resourceRepresentation =
        myIframe.contentDocument.documentElement.querySelectorAll('.rdf.object.resource.simple');
    const dropdowns = myIframe.contentDocument.documentElement.querySelectorAll('.dropdown');

    if (predicates) {
        predicates.forEach((predicate) =>
            predicate.querySelector('a').addEventListener('click', () => {
                const eldaPath = predicate.querySelector('a').href.split('-data/')[1].slice(0, -5);
                window.location.pathname = redirect(eldaPath);
                return window.location.pathname;
            }),
        );
    }

    if (resourceUrisURLs) {
        resourceUrisURLs.forEach((resource) => {
            resource.querySelector('a').addEventListener('click', () => {
                const resourcePath = resource.querySelector('a').href.split('-data/')[1];

                if (resourcePath.startsWith('id/')) {
                    window.location.pathname = redirect(resourcePath.slice(3, -5));
                    return window.location.pathname;
                } else {
                    window.location.pathname = redirect(resourcePath.slice(0, -5));
                    return window.location.pathname;
                }
            });
        });
    }

    if (resource) {
        resource.forEach((resource: any) => {
            resource.addEventListener('click', () => {
                const resourcePath = resource.href.split('-data/')[1];
                if (resourcePath.startsWith('id/')) {
                    window.location.pathname = redirect(resourcePath.slice(3, -5));
                    return window.location.pathname;
                } else {
                    window.location.pathname = redirect(resourcePath.slice(0, -5));
                    return window.location.pathname;
                }
            });
        });
    }

    if (resourceRepresentation) {
        Array.from(resourceRepresentation)
            .filter((item: any) => item.href.includes('/representation/publication'))
            .forEach((item) => {
                item.setAttribute('target', '_top');
                item.setAttribute('rel', 'noopener noreferrer');
            });
    }

    if (dropdowns) {
        dropdowns.forEach((dropdown) => {
            const textContent = dropdown.querySelector('a')?.textContent;
            if (textContent.match(/\s*data\s*format\s*/i) || textContent.toLowerCase().includes('view')) {
                const dropdownList = dropdown.querySelectorAll('li');

                dropdownList.forEach((element) => {
                    element.querySelector('a')?.setAttribute('target', '_self');
                    const domain = 'epo.org';
                    const documentUrl = document.URL;
                    const hrefUrl = element.querySelector('a')?.href;
                    if (hrefUrl) {
                        const hrefPrefix =
                            documentUrl.indexOf(domain) === -1
                                ? documentUrl
                                : documentUrl.substring(0, documentUrl.indexOf(domain));
                        const hrefSufix =
                            hrefUrl.indexOf(domain) === -1 ? hrefUrl : hrefUrl.substring(hrefUrl.indexOf(domain));
                        const assembledHref = hrefPrefix + hrefSufix;
                        // element.querySelector('a')?.href.replaceAll(element.querySelector('a')?.href, assembledHref);
                        element.querySelector('a').href = assembledHref;
                    }
                });
            }
        });
    }
};
